module.exports = __webpack_public_path__ + "img/noUser.66607358.png";